import {
  BLOCK_UNBLOCK_COUNTRY_SUCCESS,
  BLOCK_UNBLOCK_COUNTRY_FAILED,
  RESET_BLOCK_UNBLOCK_COUNTRY,
  LOADING_BLOCK_UNBLOCK_COUNTRY,
  NETWORK_ERROR_BLOCK_UNBLOCK_COUNTRY,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetBlockUnblockCountry = () => {
  return { type: RESET_BLOCK_UNBLOCK_COUNTRY };
};

const getBlockUnblockCountry = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_BLOCK_UNBLOCK_COUNTRY });
  await partnerServices
    .post("blockAndUnblockCountry", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(blockUnblockCountrysuccess(res.data));
          break;
        default:
          dispatch(blockUnblockCountryFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_BLOCK_UNBLOCK_COUNTRY, payload: err });
    });
};
function blockUnblockCountrysuccess(data) {
  return {
    type: BLOCK_UNBLOCK_COUNTRY_SUCCESS,
    payload: data,
  };
}
function blockUnblockCountryFailed(data) {
  return {
    type: BLOCK_UNBLOCK_COUNTRY_FAILED,
    payload: data,
  };
}

export { resetBlockUnblockCountry, getBlockUnblockCountry };
